// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"86059d7a","542":"300a6b39","640":"883238a7","695":"563ce2e3","820":"31d6cfe0","888":"4ff87798","961":"823acfe0"}[chunkId] + ".chunk.css";
};